/*!
  Atom, by Koding Themes
  slideshow.js
  https://kodingthemes.com
*/

function newSlideshow() {
  // slideshow onload
  var sliders = document.querySelectorAll(".new-animation-slider");
  if (sliders != null) {
    sliders.forEach(function (slider) {
      var slides = slider.querySelectorAll(".slide-item");
      var slideIndex = slider.querySelector(".slide-index");
      var slideIndexTotalText = slider.querySelector(".slide-index-total");
      var slideIndexInnerText = slider.querySelector(".slide-index-inner");

      var slideUnderline = slides[0].querySelector(".slide-animated-underline");
      if (slideUnderline != null) {
        slideUnderline.classList.add("active");
      }

      if (slideIndex != null) {
        slideIndexTotalText.innerHTML = ("0" + parseInt(slides.length)).slice(
          -2
        );
        slideIndexInnerText.innerHTML = ("0" + 1).slice(-2);
      }
    });
  }

  // Load slider js
  var constrols = document.querySelectorAll(".slide-navigation a");
  if (constrols != null) {
    constrols.forEach(function (btn, index) {
      btn.onclick = function (e) {
        e.preventDefault();
        var step = btn.dataset.slidestep;
        var slider = btn.closest(".new-animation-slider");
        var slides = slider.querySelectorAll(".slide-item");

        var slidePause = 1;
        var slideCount = parseInt(slides.length) - 1;

        var slideIndexTotalText = slider.querySelector(".slide-index-total");
        var slideIndexInnerText = slider.querySelector(".slide-index-inner");
        slideIndexTotalText.innerHTML = ("0" + parseInt(slides.length)).slice(
          -2
        );

        slides.forEach(function (slide, index) {
          if (slide.classList.contains("current-slide") && slidePause == 1) {
            var slideNext = 0;
            slider.classList.remove("slide-up");
            slider.classList.remove("slide-down");
            if (step == "next") {
              slider.classList.add("slide-up");
              slideNext = index + 1;
              if (slideNext > slideCount) {
                slideNext = 0;
              }
            } else {
              slider.classList.add("slide-down");
              slideNext = index - 1;
              if (slideNext < 0) {
                slideNext = slideCount;
              }
            }
            slides[index].classList.add("change-slide");
            slides[slideNext].classList.add("upcoming-slide");
            setTimeout(function () {
              slides[index].classList.remove("current-slide");
              slides[index].classList.remove("change-slide");
              slides[slideNext].classList.add("current-slide");
              setTimeout(function () {
                slides[slideNext].classList.remove("upcoming-slide");
                setTimeout(function () {
                  slides[index]
                    .querySelector(".slide-animated-underline")
                    .classList.remove("active");
                  slides[slideNext]
                    .querySelector(".slide-animated-underline")
                    .classList.add("active");
                }, 800);
              }, 100);
            }, 400);

            slideIndexInnerText.innerHTML = (
              "0" + parseInt(slideNext + 1)
            ).slice(-2);
            slidePause = slidePause + 1;
            //console.log(slideNext);
          }
        });
      };
    });
    // autoplay slider
    var slideNexts = document.querySelectorAll("a.slide-navigation-item-next");
    if (slideNexts.length > 0) {
      slideNexts.forEach(function (btn) {
        var sliderSection = btn.closest(".new-animation-slider");
        if (sliderSection != null) {
          var autoplay = sliderSection.dataset.autoplay;
          var speed = sliderSection.dataset.autoplaySpeed;
          speed = speed * 1000;
          if (autoplay == "true") {
            setInterval(function () {
              btn.click();
            }, speed);
          }
        }
      });
    }
    //
  }
}

document.addEventListener("DOMContentLoaded", function () {
  newSlideshow();
});
document.addEventListener("shopify:section:load", function (event) {
  newSlideshow();
});
document.addEventListener("shopify:section:unload", function (event) {
  newSlideshow();
});
document.addEventListener("shopify:section:reorder", function (event) {
  newSlideshow();
});
